import { isAfter } from 'date-fns'
import format from 'date-fns/format'
import {
    createVehicle,
    IVehicleFactory,
    Vehicle,
} from '../../entities/vehicle/Vehicle'
import { api, Api } from '../../services/api'
import {
    IVehicleResponse,
    transformVehicle,
} from '../../transformers/vehicle/VehicleTransformer'
import { IVehicleDataHandler } from './IVehicleDataHandler'
import { MOCK_CONFIG, logMockUsage } from '../../config/mock'

export class VehicleDataHandler implements IVehicleDataHandler {
    api: Api

    constructor() {
        this.api = api
    }

    async getVehicles(): Promise<Vehicle[]> {
        let data: any

        if (MOCK_CONFIG.USE_MOCK_VEHICLE_DATA) {
            // Mock data with Tel Aviv coordinates ~5km apart
            // Set arrival time to 5 minutes from now to ensure it passes filters
            const mockArrivalTime = new Date()
            mockArrivalTime.setMinutes(mockArrivalTime.getMinutes() + 5)
            // eslint-disable-next-line quotes
            const mockIsoEta = format(mockArrivalTime, "yyyy-MM-dd'T'HH:mm:ssxxx")

            data = {
                vehicle: [
                    {
                        driver_id: 'mock-vehicle-001',
                        driver_name: 'Test Driver',
                        eta: {
                            actual_eta: mockIsoEta,
                            original_eta: mockIsoEta,
                        },
                        order_id: 'mock-order-001',
                        route_id: 'mock-route-001',
                        tracking: {
                            geolocation: '32.0853 34.7818', // Tel Aviv city center
                            tracking_link: null,
                        },
                        vehicle_id: 'mock-vehicle-001',
                        vehicle_type: 'van',
                        arrival_in: 300, // 5 minutes - ensures vehicle shows immediately
                        vendor_store_info: {
                            lat: 32.0600, // Tel Aviv south area
                            lng: 34.7700,
                        },
                        show_vehicle_notification: true,
                    },
                ],
            }
            console.log('🚗 MOCK DATA CREATED:', data)
            logMockUsage('Vehicle API', true)
        } else {
            // Real API call
            const response = await this.api.client.get('sra_dashboard_columns_eta')
            data = response.data
            logMockUsage('Vehicle API', false)
        }

        const transformedVehicles: IVehicleFactory[] =
            data.vehicle.map(transformVehicle)

        console.log('🔍 TRANSFORMED VEHICLES:', transformedVehicles)

        const result = transformedVehicles
            .filter((vehicle) => {
                console.log('�� VEHICLE shouldShow FILTER:', {
                    vehicleId: vehicle.id,
                    shouldShow: vehicle.shouldShow,
                    showVehicleNotification: vehicle.shouldShow,
                    vehicle: vehicle,
                })
                return vehicle.shouldShow
            })
            .filter((vehicle) => {
                const isAfterDate = isAfter(vehicle.arrivesAt, new Date())
                console.log('🔍 VEHICLE DATE FILTER:', {
                    vehicleId: vehicle.id,
                    arrivesAt: vehicle.arrivesAt,
                    currentDate: new Date(),
                    isAfter: isAfterDate,
                    vehicle: vehicle,
                })
                return isAfterDate
            })
            .map(createVehicle)
            .sort(
                (vehicleA, vehicleB) => vehicleA.arrivesIn - vehicleB.arrivesIn
            )

        console.log('🎯 FINAL VEHICLE RESULT:', result.map(v => ({
            id: v.id,
            driverName: v.driverName,
            arrivesIn: v.arrivesIn,
            arrivalDuration: v.arrivalDuration,
            progress: v.progress(),
            geolocation: v.geolocation,
            vendorGeolocation: v.vendorGeolocation,
            shouldShow: v.shouldShow,
        })))
        return result
    }
}
